<template>
    <div>
        <GridPage
            ref="gridPage"
            :form-default="{
                user_id: null,
                status: null,
                pec: null,
                labeled_at: null,
                marunage_user_id: null,
                issued_at: null,
                sequence_number: null,
            }"
            :filters-default="{
                status: '',
                sort: 'issued_at',
            }"
            :filter-items="[
                {
                    vModel: 'status',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' },
                    ],
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▲ 日時が古い順', value: 'issued_at', },
                        { text: '▼ 日時が新しい順', value: '-issued_at' },
                    ],
                },
            ]"
            filters-q-placeholder="名前,SKU"
            form-modal-id="marunage"
            search-action="marunage/index"
            :filter-search-results="filterSearchResults"
            row-class="flex-nowrap mx-0 my--2"
            :hide-download="false"
            :hide-table="true"
            :open-detail-after-saving="false"
            item-id="id"
            @after-save="afterSave"
            @after-destroy="afterDestroy"
            >
            <template v-slot:form="{ form, init }">
                <Marunage
                    ref="model"
                    :model="form"
                    :init="init"
                    @save="$refs.gridPage.save"
                    @destroy="$refs.gridPage.destroy"

                    :response="$refs.gridPage.grid.response"
                    >
                </Marunage>
            </template>

<!--
            <template v-slot:before-table="{ response }">
                <table
                    class="table table-hover table-bordered"
                    v-if="response.data">
                    <thead class="bg-dark text-white">
                        <tr>
                            <th>
                                ユーザー
                            </th>
                            <th>
                                SKU
                            </th>
                            <th>
                                卸値
                            </th>
                            <th>
                                状態
                            </th>
                            <th>
                                ログ
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in response.data.hits">
                            <td>
                                {{ item.user.id }}.
                                {{ item.user.nickname }}
                            </td>
                            <td style="white-space: nowrap; width: 1%;">
                                {{ item.sku }}
                            </td>
                            <td class="text-right" style="white-space: nowrap; width: 1%;">
                                {{ item.cost_buying | BaseNumberFormatter }}
                            </td>
                            <td>
                                {{ trans.labels['marunage.status.' + item.status] }}
                                <div>
                                    <small v-if="item.status === 'user_wholesaled'">卸担当が確認中</small>
                                    <small v-if="item.status === 'user_draft'"></small>
                                    <small v-if="item.status === 'user_shipped'">ヤマト: <a href="#">45873897895473895</a></small>
                                    <small v-if="item.status === 'inspector_received'">検品待ち</small>
                                    <small v-if="item.status === 'inspector_checked'">ランクA+</small>
                                    <small v-if="item.status === 'inspector_repaired'">簡易清掃のみ</small>
                                    <small v-if="item.status === 'inspector_photoed'"></small>
                                    <small v-if="item.status === 'inspector_packed'">80サイズ</small>
                                    <small v-if="item.status === 'inspector_stored'">3日経過</small>
                                    <small v-if="item.status === 'inspector_shipped2buyer'">ヤマト: <a href="#">45873897895473895</a></small>
                                    <small v-if="item.status === 'inspector_shipped2d3pl'">ヤマト: <a href="#">45873897895473895</a></small>
                                    <small v-if="item.status === 'inspector_shipped2user'">FedEx: <a href="#">45873897895473895</a></small>
                                    <small v-if="item.status === 'd3pl_stored'">5日経過</small>
                                    <small v-if="item.status === 'd3pl_packed'">80サイズ</small>
                                    <small v-if="item.status === 'd3pl_shipped'">FedEx: <a href="#">45873897895473895</a></small>
                                </div>
                            </td>
                            <td>
                                <b-dropdown text="詳細" ref="dropdown" class="m-2" right>
                                    <b-dropdown-form>
                                        <table class="table table-hover table-bordered">
                                            <thead class="bg-dark text-white">
                                                <tr>
                                                    <th>
                                                        日時
                                                    </th>
                                                    <th>
                                                        状態
                                                    </th>
                                                    <th>
                                                        備考
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        2025-01-01 12:38
                                                    </td>
                                                    <td>
                                                        ユーザー：発送済
                                                    </td>
                                                    <td>
                                                        ヤマト: <a href="#">45873897895473895</a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        2025-01-02 09:01
                                                    </td>
                                                    <td>
                                                        Prova：受取済
                                                    </td>
                                                    <td>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        2025-01-02 18:33
                                                    </td>
                                                    <td>
                                                        Prova：検品済
                                                    </td>
                                                    <td>
                                                        A+
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-dropdown-form>
                                </b-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
-->
            <template v-slot:before-filter>
            </template>

            <template v-slot:after-table>
                <MarunageTable ref="table" mode="read" @on-detail="onDetail" />
            </template>
        </GridPage>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import Marunage from '@/components/Marunage.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemThumb from '@/components/ItemThumb.vue'
import ItemInfo from '@/components/ItemInfo.vue'
import MeListingListItem from '@/components/MeListingListItem.vue'
import Pagenation from '@/components/Pagenation.vue'
import MarunageTable from '@/components/MarunageTable.vue'

export default {
    components: {
        GridPage,
        Marunage,
        ItemBadges,
        ItemThumb,
        ItemInfo,
        MeListingListItem,
        Pagenation,
        MarunageTable,
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'trans',
        ])
    },
    data() {
        return {}
    },
    methods: {
        filterSearchResults(response) {
            if (response.data && response.data.hits) {
                this.$refs.table.loadData(response.data.hits)
            } else {
                this.$refs.table.loadData([])
            }
            this.$refs.table.setup()
            return response
        },
        afterSave() {
            this.$refs.gridPage.search()
        },
        afterDestroy() {
            this.$refs.gridPage.search()
        },
        onDetail(item) {
            this.$refs.gridPage.detail(item)
        },
    },
}
</script>

